// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"e81df7c0","83":"86e4754f","222":"91058c2a","816":"ae1c9f25","873":"1a1b7e7b","948":"3f35cf24"}[chunkId] + ".chunk.js";
};